import React from "react";
import ChoiceTiles, { ChoiceTile } from "../../../common/inputs/ChoiceTiles";
import { ProcedureTypeOption } from "../../../../types";

/**
 * Die drei Antragsarten, mit denen fast jedes Projekt beginnt – sie stehen ohne Aufklappen da.
 * Alle übrigen folgen in der Reihenfolge des Servers.
 */
const FEATURED_CODES = ["NEUE_ANLAGE_P10", "NEUE_ANLAGE_P19", "REPOWERING"];

interface ProcedureTypeTilesProps {
  options: ProcedureTypeOption[];
  onSelect: (option: ProcedureTypeOption) => void;
}

/** Kurzname, darunter klein der ELiA-Wortlaut */
const toTile = (option: ProcedureTypeOption): ChoiceTile => ({
  id: option.id,
  title: option.kurzname || option.name,
  caption: option.kurzname ? option.name : undefined,
});

/**
 * Erster Schritt beim Anlegen eines Antrags: die Antragsart als Kacheln (ChoiceTiles).
 * Keine Kachel ist hervorgehoben – auch nicht die, die der Server vorbelegen würde.
 */
const ProcedureTypeTiles: React.FC<ProcedureTypeTilesProps> = ({
  options,
  onSelect,
}) => {
  const featured = FEATURED_CODES.map((code) =>
    options.find((option) => option.code === code),
  ).filter((option): option is ProcedureTypeOption => !!option);
  const others = options.filter(
    (option) => !FEATURED_CODES.includes(option.code),
  );

  return (
    <ChoiceTiles
      tiles={featured.map(toTile)}
      moreTiles={others.map(toTile)}
      onSelect={(id) => {
        const option = options.find((o) => o.id === id);
        if (option) onSelect(option);
      }}
    />
  );
};

export default ProcedureTypeTiles;
